// src/service/FichaUsuario.js
import instance from '../apis/app';

const FichaUsuario = {
  getFicha: async (userId) => {
    const response = await instance.get(`/admin/usuarios/${userId}/ficha`);
    return response.data?.data ?? response.data;
  },
};

export default FichaUsuario;
